module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DREAMS and VISIONS")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "ct1",
    attrs: {
      "id": "p0019-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#a_1",
      "id": "b_1"
    }
  }, [_c('b', [_vm._v("ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0019-01-01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter2#a_1"
    }
  }, [_vm._v("Friday at the Khan")])])]), _vm._v(" "), _c('p', [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "p0019-02-1"
    }
  }, [_c('span', {
    staticClass: "dcap3"
  }, [_vm._v("Y")]), _c('span', [_vm._v("ou’re the one!” A woman’s shout broke above the pandemonium of Cairo’s Khan el-Khalili Friday Market. “You’re the one!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-2"
    }
  }, [_c('span', [_vm._v("Kamal Assam spun toward the voice. His eyes fixed on the black hijab walking toward him. A female hand protruded from the full-body covering, pointing in his direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-3"
    }
  }, [_c('span', [_vm._v("“Yes! You!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-4"
    }
  }, [_c('span', [_vm._v("Instincts begged him to ignore this culturally dangerous assault and dissolve into the crowd. If the woman’s husband were anywhere near and saw her approach, she—and likely Kamal—would pay a steep price for this outburst. Kamal couldn’t fathom why an observant Muslim woman would choose today to potentially ruin his life. Then a calmer voice inside suggested this might be the very reason Kamal had made his unusual trip to the marketplace.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-5"
    }
  }, [_c('span', [_vm._v("“You were in my dream last night.” The woman, now close enough to be heard without shouting, breathed heavily from the "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("effort of pushing through the mob and from her own shock at the unfolding mystery of her circumstances.")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-02-2"
    }
  }, [_c('span', [_vm._v("“Those clothes. You were wearing those clothes. For sure, it is you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-03-4"
    }
  }, [_c('span', [_vm._v("Kamal instantly recognized why this person had so passionately invaded his life. “Was I with Jesus?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-04-6"
    }
  }, [_c('span', [_vm._v("“Yes,” the woman cried, “Jesus was with us!”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-05-8"
    }
  }, [_c('span', [_vm._v("What had begun as an atypical visit for him to the Friday Market had just taken an even more uncanny and exciting turn. That morning while reading his Bible, Kamal felt a compelling urge to leave the house where he was staying and venture to the Friday Market. At the heart of Egypt’s capital city, the Khan el-Khalili is as much an arena as a marketplace. A Mamluk prince built it in 1382, and in some places it smells that old. No ordinary souk (marketplace), this massive outdoor mall is next to the famed Hussein mosque and even has a hotel for those who want to mix religion with shopping. Whether a kitchen utensil, sumac spice, or pair of Nike knockoffs, most anything—legal and otherwise—is sold there.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-06-10"
    }
  }, [_c('span', [_vm._v("A short walk from the Khan stands Al-Azhar University, the oldest degree-granting university in Egypt and the chief center for Sunni Islam worldwide. For Arab Muslims, this is the promised land and the reason that a suicide bomber detonated himself in the middle of the Khan on April 7, 2007.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-07-12"
    }
  }, [_c('span', [_vm._v("The attack was a response to the government’s treatment of another group of terrorists that had bombed the Hilton Taba by the Red Sea in the Sinai Peninsula on the same day in 2004. In that attack, thirty-one Jews were left dead.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-08-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("The terrorist act in April 2007 sent a message to the government: stay out of any dealings with Jews. As a result of the ")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("bombing in the capital of Sunni Islam, from then on no place in Cairo was considered safe. Tourism in Egypt collapsed—at least for a while.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-02-2"
    }
  }, [_c('span', [_vm._v("But now the hordes were back. Tourists weren’t thinking of terrorist attacks. They focused on getting a good deal on some fine pashmina goat’s wool without getting a wallet lifted in between negotiations with a local merchant. Any tourist who dared enter the Khan would be fortunate to leave with only the money spent on trinkets missing from his or her person. The poor of Cairo “shop” here, a population that includes some of the world’s most skilled pickpockets. And only veteran locals with calloused olfactory sense can long endure the stench. Most of the items are secondhand—some stolen—but the bargains are irresistible, so consumers, indigenous and tourist alike, endure the tidal wave of unpleasantness. Fistfights and brawls are common. Shoppers create their own paths through the chaos of merchandise, animals, and human beings, jostling other marketgoers out of the way to achieve their buying goals.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-03-4"
    }
  }, [_c('span', [_vm._v("The senseless layout reflects all of life in Cairo, like the downtown motor traffic where eight rows of cars cram into three lanes. Neither the drivers there nor the clientele on foot in the market have any hope of maintaining full control of where they go.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-04-6"
    }
  }, [_c('span', [_vm._v("The market’s entertainment options are as bizarre as its product offerings. Fire-eaters and magicians compete with card-trick artists and glass eaters for an audience. And human forms in alien costumes with no discernible purpose roam among the thousands of Muslim men and women frantically shopping to complete their secular business before Friday prayers shut down commerce for the rest of the day."), _c('br'), _c('br')])])]), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0022-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("A V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EILED")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMAN AND")]), _vm._v(" A S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INGLE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")])])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "p0022-02-1"
    }
  }, [_c('span', [_vm._v("So why would Kamal brave this Friday free-for-all? Only the most urgent of necessities ever compelled him to attend, and even then, he avoided the central market area by using one of the less-thriving entryways. But this particular Friday, he went because God told him to go. He knew with 100 percent certainty God had an assignment waiting for him there. The details of the mission were a mystery to him, but he was used to trusting God in the face of the unknown.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-4"
    }
  }, [_c('span', [_vm._v("So when the market opened at 8 a.m., Kamal was there. He had briefly resisted the urge to avoid the central market and visit the relatively less mobbed areas he preferred—if anything could be “preferred” about the marketplace—but he yielded even that desire to what he knew was God’s prompting and found himself crushed and battered by the crowd while he waited for he wasn’t sure what.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-04-5"
    }
  }, [_c('span', [_vm._v("That someone would notice Kamal among the hordes is not surprising. His friends think of him as the friendliest person in all of Egypt. His smile shines a block away, and his large, green eyes are unforgettable. Joy radiates from every cell of his body, and he is immediately likable. Even when he was arrested for evangelizing Muslims and questioned for hours by the secret police, they ended the interrogation by telling him how glad they were he had stopped by for a visit!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0022-05-7"
    }
  }, [_c('span', [_vm._v("Kamal loves Jesus with his whole heart and is a remarkable pray-er. It’s an experience of heaven simply to be in the room when he prays. One man, upon hearing Kamal pray for the first time, was so overwhelmed by Kamal’s passion for God that he sat speechless for several minutes after the prayer was over.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Kamal wants to be married, and he will tell anyone that. And one other personal characteristic also makes him stand out in a crowd: he’s overweight, but he’s “working on it.” Still, none of these personal characteristics mattered the moment Noor, a committed Muslim mother of eight, spotted him in the Khan.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-02-2"
    }
  }, [_c('span', [_vm._v("“Jesus walked with me alongside a lake, and He told me how much He loves me.” The woman in black told Kamal details of the vivid dream she’d had the night before their meeting. “I think my husband loved me at one time. But that love I felt in my dream— His love—was different than anything I’ve ever experienced. I’ve never felt so much peace in my heart. I didn’t want to leave. I didn’t want Him to leave. I asked this Jesus, ’Why are You visiting me, a poor Muslim mother with eight children?’ And all He said was, ’I love you, Noor. I have given everything for you. I died for you.’ ”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-03-4"
    }
  }, [_c('span', [_vm._v("The din of the market faded from Kamal’s consciousness. He heard only Noor describing her otherworldly encounter with Jesus Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-6"
    }
  }, [_c('span', [_vm._v("“As He turned to leave, the last thing Jesus said was, ’Ask My friend tomorrow about Me. He will tell you all you need in order to understand why I’ve visited you.’ ’But, Jesus, who is Your friend?’ I pleaded in my dream. ’Here is My friend.’ Jesus pointed behind us. ’He has been walking with us the whole time we’ve been together.’ ”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-04-7"
    }
  }, [_c('span', [_vm._v("Only partially veiled, Noor stared at Kamal as if she’d been looking for him her whole life. She continued, “Before He said that, I had not noticed you. But you were there—standing nearby through the whole dream. Even though you had walked with us around the lake, I hadn’t seen anyone but Jesus. I thought I was alone with Him. His face was magnificent. I couldn’t take my eyes off Him.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("“Jesus did not tell me your name, but you were wearing the same clothes you have on right now, and your glasses . . . they’re the same too. In my dream, your face radiated in a way that told me Jesus was, indeed, your friend. I knew I would not forget your smile.”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-02-2"
    }
  }, [_c('span', [_vm._v("Kamal led Noor out of the main crowd to the edge of the souk and a patch of grass under a lone tree. The two sat down before Kamal spoke.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-03-4"
    }
  }, [_c('span', [_vm._v("“Noor, my name is Kamal, and I’m a Jesus follower. I have loved Him with an undivided heart for ten years now and am honored to have been in your dream.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-04-6"
    }
  }, [_c('span', [_vm._v("Noor stared into Kamal’s green eyes, enthralled with the man’s words.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-05-8"
    }
  }, [_c('span', [_vm._v("“Jesus is touching the hearts of Muslims all over the world. He’s calling them to salvation—real salvation—one at a time, by visiting them in dreams and visions.” Kamal paused, thinking. “Is this your first dream about Jesus?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-06-10"
    }
  }, [_c('span', [_vm._v("Noor answered, hope in her eyes. “Yes, it’s my first. Will I have more dreams?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-07-12"
    }
  }, [_c('span', [_vm._v("Kamal measured his answer. “You might have many dreams about Jesus. It depends on what He plans for you. It could be that one dream is all you need.” Kamal wondered briefly just what his Lord had in mind for this woman. “You must have many questions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-07-13"
    }
  }, [_c('span', [_vm._v("“About a thousand,” Noor blurted.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-08-15"
    }
  }, [_c('span', [_vm._v("“Is this a safe place to talk?”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-09-17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Noor understood the question behind the question. “My husband is at work, and besides, he lost interest in me long ago. I’m his third wife, and last year he took a fourth. She is very young, and her smooth skin, beautiful face, and shapely silhouette are all he ")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("can think about. I barely see him. He won’t come looking for me.” Anguish flickered across her face, but wonder quickly returned. “We are safe here. Tell me about Jesus!”")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-02-2"
    }
  }, [_c('span', [_vm._v("Kamal spoke slowly. “He is calling you, Noor. He doesn’t make random visits. Your dream has a purpose that will transform you on the inside.” Kamal watched Noor to make sure she understood. “Jesus wants you to be one of His followers. You’ve been privileged to have a personal visit from Jesus Christ. You are chosen, Noor. Even before you were born, Jesus planned this encounter with you.” Kamal looked away, into the mass of people surrounding them, then back at Noor. “He has not yet appeared to me like this, but I pray that He does.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-03-4"
    }
  }, [_c('span', [_vm._v("Noor felt authority she could trust in Kamal’s voice. She sighed deeply and put words to her first question: “Why would a prophet say that He died for me? I have believed in Him, and we Muslims respect Him.” Noor stared past Kamal, slowly shaking her head. “But He is much more than I thought He was. I have never been loved like I was when Jesus walked with me in that dream. I felt no fear.” She looked again at Kamal. “For the first time in my life, I felt no shame.” Her voice dropped to a whisper; Kamal strained to hear her. “Even though He’s a man, I wasn’t intimidated. I didn’t feel threatened. I felt . . . perfect peace.” Noor smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-04-6"
    }
  }, [_c('span', [_vm._v("Kamal feared that discussing Islam could drive Noor away, but he boldly turned the conversation in that direction. “That’s what He wants to give you, Noor. Before He went to the cross, Jesus said, ’Peace I leave with you, My peace I give to you’ (John 14:27 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NKJV")]), _vm._v("). You will not—cannot—find peace like that with anyone else. No one but Jesus even has it to offer.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("Kamal continued, “Noor, you’ve spent your life searching for ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("God through religion. I did the same thing. My religion was different than yours, but in the end, all religions amount to the same thing: frustration. They’re filled with man-made rules that will supposedly get you to God. But the fact is, they don’t.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-02-2"
    }
  }, [_c('span', [_vm._v("Kamal could see in her eyes that Noor grasped this painful truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-03-4"
    }
  }, [_c('span', [_vm._v("“Do you ever feel frustrated like that, Noor?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-04-6"
    }
  }, [_c('span', [_vm._v("“Yes. Yes, I do. Every day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-05-8"
    }
  }, [_c('span', [_vm._v("“Noor, have you ever watched people after daily prayers?” Kamal asked, not waiting for an answer. “I’ve sat outside the Al-Azhar Mosque on Friday as the ’faithful’ come out from noon prayers. They never look very happy—or fulfilled. They don’t have the kind of peace I see all over your face right now. Religion can’t give you that. Your religion can’t give you that.” He let the words sink in.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-06-10"
    }
  }, [_c('span', [_vm._v("Noor bristled. She studied Kamal’s face, her teeth lightly clenched. She glanced at the ground and then eyed Kamal solemnly. “Are you asking me . . . to leave Islam?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-07-12"
    }
  }, [_c('span', [_vm._v("Kamal had stepped into the mine field. “I’m not asking you to do anything, Noor. But Jesus is asking you to follow Him.” The sincerity in his deep, jade eyes validated his words. “Do you believe your dream was real?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-08-14"
    }
  }, [_c('span', [_vm._v("Noor’s shoulders dropped as calm settled over her black form. She gazed at the ground. “I know it was real. It has shaken me to my core. I must find out all about Him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-09-16"
    }
  }, [_c('span', [_vm._v("“Then I will do my best to answer every question you have.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-09-17"
    }
  }, [_c('span', [_vm._v("Three hours later, questions and answers still flowed between Kamal and Noor on their grass island. Finally, Noor threw back her head and exhaled deeply, pleased with their progress but exhausted from the influx of strange, new information.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("“What do I do with all I’ve learned today? When I give my life to Jesus and I’m new on the inside, will I still be a Muslim?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-02-2"
    }
  }, [_c('span', [_vm._v("Kamal didn’t answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-03-4"
    }
  }, [_c('span', [_vm._v("Suddenly, Noor sat up straight. The energy of resolve rose in her voice. “I’m ready now. I want to follow Jesus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-04-6"
    }
  }, [_c('span', [_vm._v("“Are you willing to be persecuted for Jesus?” Kamal surprised himself with the question.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-05-8"
    }
  }, [_c('span', [_vm._v("Noor sat silently.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-06-10"
    }
  }, [_c('span', [_vm._v("Kamal’s next question was even more unexpected. “Are you willing to die for Him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-07-12"
    }
  }, [_c('span', [_vm._v("Noor seemed less shocked by the question than Kamal. “Is that what He’s calling me to do?” she asked as matter-of-factly as if she wondered whether Jesus might want her to buy grapes at the market.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-08-14"
    }
  }, [_c('span', [_vm._v("Now Kamal stared through the Friday crowd, wondering again what this brave woman’s future may hold. “It could well be your fate, Noor. Jesus told His followers on the night He was arrested that there would be harsh persecutions for those who follow Him.” He returned his focus to Noor. “It’s our privilege to suffer like He did. He warned that ’the time is coming when anyone who kills you will think they are offering a service to God’ (John 16:2).”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0027-09-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Noor sighed. “Jesus was talking about Islam. He had to be. That’s what happens to Muslims who convert.” Noor folded her hands and pressed them to the ground. “I should tell you something, Kamal. I saw a television program a month ago. Father Zakaria was talking about Jesus, and a few people called in to the program to debate him. He handled them with ease. I was amazed, though, because most of the people told him how Jesus had changed their lives. I could not believe my ears. These were Muslims! I remember ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("thinking that they would probably die because of leaving Islam. Their families would see to that. You know all about honor killing, I presume?”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-02-2"
    }
  }, [_c('span', [_vm._v("They looked at each other for several seconds in silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-03-4"
    }
  }, [_c('span', [_vm._v("Noor nodded slightly in recognition of a new thought. “Jesus knew this was coming, didn’t He?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-04-6"
    }
  }, [_c('span', [_vm._v("“I think He did,” Kamal responded soberly.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-05-8"
    }
  }, [_c('span', [_vm._v("Noor sucked in her breath, exhaled, and watched a shopper brush past. “Well, I’m not afraid. But . . . I have to think about this. I must go to the mosque or to some place private. I must pray. What about my children? It’s all so new. I . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-06-10"
    }
  }, [_c('span', [_vm._v("Kamal smiled the same smile Noor had seen in her dream. “I understand. I will never forget this encounter, Noor. Neither should you. Jesus has made you a wonderful offer that you only have to accept. He is calling you. I will pray. Until we meet again.”"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0028-07-12"
    }
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAMS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OME")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "p0028-08-13"
    }
  }, [_c('span', [_vm._v("Noor’s dream opened the door to her heart and mind and prepared her in this startling way to receive salvation one day. But something about Egypt and dreams seem to go together. The two have been connected since the first book of the Bible. Men of God in the Old Testament had dreams and visions. Isaiah’s book was a vision. Daniel saw visions. So did Ezekiel. But so did Egyptian pagan kings.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0028-09-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Outside of the Scriptures, Egyptian history records a significant amount of information about dreams and visions, many of which became determining factors in the overall direction of the ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("nation. Messages “from beyond” were so revered that they often played a decisive role in a pharaoh’s national plans or governing policies.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-02-2"
    }
  }, [_c('span', [_vm._v("Egyptian rulers regularly had their dreams analyzed when deciding whether to wage war or build a temple to a new god. Divine messages were considered accurate predictors of the future, and no dream was discounted. Scribes recorded dreams to support the pharaoh’s actions at critical junctures in history.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-03-4"
    }
  }, [_c('span', [_vm._v("One archaeological find close to the Pyramids revealed that an ancient Egyptian scribe named Kenhirkhopeshef kept a papyrus document called the "), _c('i', [_vm._v("Dream Book")]), _vm._v(". The book is a catalog of 108 dreams and the activities and emotions that accompanied them. As evidenced by the variety of ancient Egyptian dialects used in the writing, this journal was handed down through the generations.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0029-04-6"
    }
  }, [_c('span', [_vm._v("The "), _c('i', [_vm._v("Dream Book ")]), _vm._v("demonstrates highly subjective interpretations. Similar dreams that occurred at different times had widely differing interpretations. Some of the dreams addressed the struggles of everyday life, such as financial gain and loss, fasting, overeating, gossip, anger, drinking, pleasure, and ethics. One particularly fascinating aspect of the book is its division into two parts—“good dreams” and “bad dreams” (the bad dreams were written in red ink). Egyptians believed the gods could judge hearts and evaluate all human motives. Dreams and visions were one way in which the whims of the gods were revealed. Were the gods pleased or displeased with the Egyptians’ efforts? What would be their ultimate fate in eternity? They were on the right theological track, but they had the wrong deity. Like no other nation, Egypt has been imprinted by dreams and visions.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Little wonder, then, that the God of Israel gave dreams to Pharaoh when Joseph was in an Egyptian prison. The ruler’s troubling dreams set off alarms in the palace that wouldn’t shut off until the king was certain of the interpretation. Priests, magicians, and wise men were at Pharaoh’s disposal anytime a dream needed to be deciphered. But God spoke truth only through Joseph. All the other dream specialists were frauds, incapable of providing the correct interpretation to the king. It’s no wonder Joseph made the quantum leap from prisoner to prime minister. From the days before his brothers sold him, Joseph had known the power, as well as the danger, of dreams."), _c('br'), _c('br')])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0030-02-2"
    }
  }, [_c('span', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GYPTIAN")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAMS")]), _vm._v(", U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOSE AND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSONAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "p0030-03-3"
    }
  }, [_c('span', [_vm._v("Recently, my son John-Mark and I visited the Pyramids in Giza. These magnificent creations are just a short distance from Cairo, and if you survive the wild taxi ride there, you won’t be disappointed. (A ride in an Egyptian taxi transforms you into a prayer warrior from the moment you leave the curb.)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-03-4"
    }
  }, [_c('span', [_vm._v("The Sphinx, also located at Giza, was built around 2500 BC— about seven hundred years before Joseph came to Egypt and eleven hundred years before Moses’ time. Although this curious creature with a human head and body of a lion is crumbling because of wind, humidity, and the smog from Cairo, it has managed to survive this long in part because it was buried in sand for almost one thousand years—until King Thutmose IV had a dream.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0030-04-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("As a young prince in Egypt, Thutmose claimed that a god spoke to him in a dream at the Sphinx after he had spent the day ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("hunting near there. Thutmose had fallen asleep beside the small portion of the creature that protruded above the sand at the time. The god Hamarkis told Thutmose to clear away the sand from the Sphinx since it was choking the creature. Hamarkis promised that if Thutmose was faithful to this task, he would be rewarded with a kingship. The young prince cleared away the sand and soon became king over Egypt.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-02-2"
    }
  }, [_c('span', [_vm._v("King Thutmose IV was one of the most feared kings of the Eighteenth Dynasty and well known for his bloodthirsty reign. To commemorate his alleged dream and to add credibility to his kingship, Thutmose placed a stela (an inscribed stone marker) between the front paws of the Sphinx telling his story. The Dream Stela is still there today and in fairly good shape, considering that it is more than thirty-four hundred years old.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-03-4"
    }
  }, [_c('span', [_vm._v("What’s curious about this particular event is that no one could verify that this dream actually took place. The prince told the story, and it became the basis for his kingship. The only evidence was his unsubstantiated testimony.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-04-6"
    }
  }, [_c('span', [_vm._v("With a history like this, people pay attention when dreams hit home. And Christ followers like Kamal are the new Josephs, placed there by God to interpret dreams. The need for explanation is so great, in fact, that this ad appeared recently in the "), _c('i', [_vm._v("Cairo Times")]), _vm._v(": “Have you seen a man in a white robe in a dream? If so, call this number . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0031-05-8"
    }
  }, [_c('span', [_vm._v("Ah, the power of dreams in Egypt!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb726508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter7.vue
// module id = 81
// module chunks = 0